import React, { useState, useEffect } from "react";
import classes from "./CustomActions.module.scss";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import PersianPrice from "../../components/PersianPrice/PersianPrice";
import useWindowSize from "../../hooks/useWindowsSize";
import { useTranslation } from "react-i18next";

export default function CustomActions({
  page,
  setPage,
  dataLength,
  rowsPerPage,
}) {
  const windowSize = useWindowSize();
  const { i18n } = useTranslation();
  // const [isDisableAction, setIsDisableAction] = useState(
  //   dataLength > rowsPerPage
  // );
  const [isNextDisable, setIsNextDisable] = useState(
    dataLength / rowsPerPage === page + 1 ? false : true
  );

  const [isPrevDisable, setIsPrevDisable] = useState(page === 0 ? false : true);

  // useEffect(() => {
  //   setIsDisableAction(dataLength > rowsPerPage);
  // }, [dataLength, rowsPerPage]);

  useEffect(() => {
    setIsNextDisable(dataLength / rowsPerPage <= page + 1 ? false : true);
    setIsPrevDisable(page === 0 || rowsPerPage === -1 ? false : true);
  }, [page, dataLength, rowsPerPage]);

  useEffect(() => {
    if (page > dataLength / rowsPerPage) {
      if (rowsPerPage === -1) {
        setPage(0);
      } else {
        setPage(Math.floor(dataLength / rowsPerPage));
      }
    }
  }, [rowsPerPage]);

  function handleClick(type) {
    if (type === "next") {
      setPage(() => setPage(page + 1));
    } else if (type === "previous") {
      setPage(() => setPage(page - 1));
    }
  }

  return (
    <div className={windowSize.width > 430 ? classes.root : classes.mobileRoot}>
      <ul className={classes.list}>
        <li
          onClick={isNextDisable ? () => handleClick("next") : ""}
          className={isNextDisable ? classes.items : classes.disabled}
        >
          <KeyboardArrowRightIcon />
        </li>
        <li className={classes.middleItem}>
          {" "}
          {i18n.language === "fa" ? (
            <PersianPrice number={page + 1} />
          ) : (
            page + 1
          )}
        </li>
        <li
          onClick={isPrevDisable ? () => handleClick("previous") : ""}
          className={isPrevDisable ? classes.items : classes.disabled}
        >
          <KeyboardArrowLeftIcon />
        </li>
      </ul>
    </div>
  );
}
